<template>
  <div class="card-section not-found-section card mt-4 mb-3">
      <div class="row h-100">
        <div class="card-body g-0 d-flex align-items-center justify-content-center">
          <img src="@/sass-template/content/images/not-found.svg" class="img-fluid" alt="">
          <p class="mb-0 ms-3">No photos or videos available for that case</p>
        </div>
      </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({});
</script>
